module.exports = __webpack_public_path__ + "img/mobileApplicationDevelopment.51c9707e.jpg";